import { createSelector } from 'reselect';
import { DataState } from '../state';

export const subAccountSelectors = {
  getSubAccounts: createSelector(
    [(state: DataState) => state.subAccountManagement.subAccounts],
    subAccount => subAccount
  ),
  getMasterSubAccountId: createSelector(
    [(state: DataState) => state.account.subaccounts.subaccounts],
    subAccounts => subAccounts && subAccounts.length > 0 && subAccounts.find(s => s.IsMaster)!.Id
  ),
};
